import React from 'react';
import PropTypes from 'prop-types';
import { EntityIllustration } from 'front-onceforall-core';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const OrganisationItem = props => {
  const organisation = props.organisation;
  const address = organisation.address;
  const organisationItem = /*#__PURE__*/_jsx("div", {
    className: "row",
    children: /*#__PURE__*/_jsx("div", {
      className: "col-12",
      children: /*#__PURE__*/_jsxs("div", {
        className: 'box my-2 flex-container clickable',
        children: [/*#__PURE__*/_jsx("div", {
          className: "col-sm-2 inline-container column justify-content-center",
          children: /*#__PURE__*/_jsx(EntityIllustration
          // imageUrl={getOrganisationLogoUrl(props.organisation.organisationId)}
          , {
            country: props.organisation.country,
            name: props.organisation.fullName,
            small: true
          })
        }), /*#__PURE__*/_jsxs("div", {
          className: "col-sm-5 inline-container column justify-content-center",
          children: [/*#__PURE__*/_jsx("strong", {
            "data-id": "fullName",
            children: organisation.fullName
          }), /*#__PURE__*/_jsx("span", {
            "data-id": "registrationNumber",
            children: organisation.registrationNumber
          })]
        }), /*#__PURE__*/_jsxs("div", {
          className: "col-sm-5 inline-container column justify-content-center",
          children: [/*#__PURE__*/_jsx("span", {
            "data-id": "addressLine",
            children: address.addressLine
          }), /*#__PURE__*/_jsx("span", {
            "data-id": "city",
            children: address.city
          })]
        })]
      })
    })
  });
  return /*#__PURE__*/_jsx(_Fragment, {
    children: organisationItem
  });
};
OrganisationItem.propTypes = {
  organisation: PropTypes.object.isRequired
};
export default OrganisationItem;